import type { UserInfoDTO } from '@/global/GlobalType';

const isBlank = (value?: string | null): boolean => !value || !String(value).trim();

/** 姓名、昵称均未设置，或未设置头像时需引导完善资料 */
export const needsProfileSetup = (user: UserInfoDTO | null | undefined): boolean => {
  if (!user) {
    return false;
  }
  const noRealName = isBlank(user.realName);
  const noNickname = isBlank(user.nickname);
  const noAvatar = isBlank(user.userAvatar);
  return (noRealName && noNickname) || noAvatar;
};
